import React, { useEffect, useState } from "react";
import "./Dp_style.css";
import { Field, Form, ErrorMessage } from "formik";
import {
  Box,
  TextField,
  InputAdornment,
  FormControl,
  Typography,
  useTheme,
  InputLabel,
} from "@mui/material";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { tokens } from "../../../../theme";
import dayjs from "dayjs";
import "dayjs/locale/fa"; 

const DateTimePicker = (props) => {
  const { name, label,error,helperText, ...rest } = props;
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const sxStyle = {
    fontFamily: "yekan !important ",
    borderRadius: "4px",
    width: "100%",
    textAlign: "center",
    padding: " 8px",
    "& .muirtl-aqwd4r-MuiFormLabel-root-MuiInputLabel-root": {
      color: colors.grey[100],
    },
  };
 
  
  return (
    <Field name={name}>
      {({ form, field }) => {
        let day = new Date().toJSON();
        const { setFieldValue } = form;
        const { value } = field;
        return (
          <FormControl sx={sxStyle}>
            <DatePicker
              disabled={props.disable?props.disable:false}
              disableMaskedInput
              label={label}
              id={name}
              value={value ? dayjs(value) : dayjs()}
              {...field}
              {...rest}
              fullwidth
              onChange={(newValue) => {
                if (newValue && newValue._d) {
                  setFieldValue(name, JSON.stringify(newValue._d).slice(1, 20));
                } else {
                  // Handle case where newValue is null or undefined
                  setFieldValue(name, ''); // Clear the field value or handle it as per your requirement
                }
              
              }}
              renderInput={(params) => <TextField 
                {...params}
                size="small" 
                // error={error}
                // helperText={helperText}
                 />}
            />
          </FormControl>
        );
      }}
    </Field>
  );
};

export default DateTimePicker;


